var cnt = document.createElement('div');

// Возможно, надо будет вынести
function render(html) {

    if (html instanceof Array) {
        html = html.join('');
    }

    cnt.innerHTML = html;

    var el = cnt.children[0];

    cnt.removeChild(el);

    return el;
}

export default function(classes) {
    return render([
        '<div class="sc-menu sc-menu__hidden ' + classes.join(' ') + '">',
            '<div class="sc-menu_arw_w">',
                '<div class="sc-menu_arw"></div>',
            '</div>',
        '</div>'
    ]);
};
